import React, { useState } from 'react';
import { Layout, Button, Drawer, Menu, Badge } from 'antd';

import {
  AiOutlineCheck,
  AiOutlineCluster,
  AiFillContainer,
} from 'react-icons/ai';

import {
  FaCubes,
  FaCube,
  FaMoneyBillTransfer,
  FaRightLeft,
  FaHandshake,
  FaUsersViewfinder,
  FaGlobe,
  FaWhatsapp,
  FaMobileScreen,
  FaCashRegister,
  FaArrowTrendUp,
  FaArrowTrendDown,
  FaMotorcycle,
  FaRegClipboard,
} from 'react-icons/fa6';

import {
  FaCompressArrowsAlt,
  FaTv,
  FaCompressAlt,
} from 'react-icons/fa';

import {
  LogoutOutlined,
  MenuOutlined,
  TeamOutlined,
  BarChartOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  AppstoreOutlined,
  PictureOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  DesktopOutlined,
} from '@ant-design/icons';

import { Link } from 'react-router-dom';

import { Title_1, Title_2 } from '../global';
import { usePedidos } from '../context/PedidosContext';

const { Header } = Layout;
const { SubMenu } = Menu;

const CustomHeader = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const { novosPedidosCount } = usePedidos();

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <>
      {/* =========================
          HEADER
      ========================== */}
      <Header
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'white',
          padding: '0 20px',
          height: '64px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
      >
        {/* =========================
            LADO ESQUERDO
        ========================== */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={showDrawer}
            style={{
              fontSize: '20px',
            }}
          />

          <a
            href="/"
            className="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto link-body-emphasis text-decoration-none"
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            {/* Logo */}
            <img
              src="/logo-loja.png"
              alt="Logo"
              width={60}
              height={60}
              style={{
                marginRight: 10,
                objectFit: 'contain',
              }}
            />

            {/* Títulos */}
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
              }}
            >
              <span
                style={{
                  fontWeight: 700,
                  fontSize: '20px',
                  color: 'black',
                }}
              >
                {Title_1}
              </span>

              <span
                style={{
                  fontWeight: 300,
                  fontSize: '20px',
                  paddingLeft: 5,
                  color: 'black',
                }}
              >
                {Title_2}
              </span>
            </div>
          </a>
        </div>

        {/* =========================
            NAVEGAÇÃO CENTRAL
        ========================== */}
        <div className="nav-buttons">
          <Button
            type="link"
            style={{
              color: 'black',
            }}
          >
            <Link to="/">
              Terminal
              <Badge
                count={novosPedidosCount}
                overflowCount={99}
                style={{
                  marginLeft: 4,
                }}
              />
            </Link>
          </Button>

          <Button
            type="link"
            style={{
              color: 'black',
            }}
          >
            <Link to="/pdv">PDV</Link>
          </Button>

          <Button
            type="link"
            style={{
              color: 'black',
            }}
          >
            <Link to="/orders">Pedido(s)</Link>
          </Button>

          <Button
            type="link"
            style={{
              color: 'black',
            }}
          >
            <Link to="/users">Cliente(s)</Link>
          </Button>

          <Button
            type="link"
            style={{
              color: 'black',
            }}
          >
            <Link to="/produtos">Produto(s)</Link>
          </Button>

          <Button
            type="link"
            style={{
              color: 'black',
            }}
          >
            <Link to="/desempenhos">Desempenho</Link>
          </Button>
        </div>

        {/* =========================
            LOGOUT
        ========================== */}
        <Button
          className="nav-buttons"
          type="text"
          icon={<LogoutOutlined />}
          style={{
            fontSize: '16px',
            fontWeight: 'bold',
          }}
        >
          <Link to="/logout">Sair</Link>
        </Button>
      </Header>

      {/* =========================
          DRAWER / MENU LATERAL
      ========================== */}
      <Drawer
        title="Menu"
        placement="left"
        onClose={closeDrawer}
        open={drawerVisible}
        styles={{
          body: {
            padding: 0,
          },
          footer: {
            padding: 0,
            borderTop: '1px solid #f0f0f0',
          },
        }}
        footer={
          <Menu
            mode="inline"
            selectable={false}
          >
            <Menu.Item
              key="logout"
              icon={<LogoutOutlined />}
            >
              <Link to="/logout">Logout</Link>
            </Menu.Item>
          </Menu>
        }
      >
        <Menu
          mode="inline"
          style={{
            height: '100%',
            borderRight: 0,
          }}
          onClick={closeDrawer}
        >
          {/* =========================
              ATENDIMENTO
          ========================== */}
          <Menu.Item
            key="atendimento"
            icon={<FaTv />}
          >
            <Link to="/">Terminal</Link>
          </Menu.Item>

          {/* =========================
              DASHBOARD
          ========================== */}
          <Menu.Item
            key="dashboard"
            icon={<DesktopOutlined />}
          >
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>

          {/* =========================
              PEDIDOS
          ========================== */}
          <Menu.Item
            key="pedidos"
            icon={<FaRegClipboard />}
          >
            <Link to="/orders">Pedidos</Link>
          </Menu.Item>

          {/* =========================
              CANAIS DE VENDAS
          ========================== */}
          <SubMenu
            key="canais"
            icon={<FaUsersViewfinder />}
            title="Central de Vendas"
          >
            <Menu.Item
              key="site"
              icon={<FaGlobe />}
            >
              <a
                href="https://bebilogo.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                E-commerce
              </a>
            </Menu.Item>

            <Menu.Item
              key="app"
              icon={<FaMobileScreen />}
            >
              <a
                href="https://app.bebilogo.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                App
              </a>
            </Menu.Item>

            <Menu.Item
              key="cardapio"
              icon={<AiFillContainer />}
            >
              <a
                href="https://cardapio.bebilogo.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cardápio Digital
              </a>
            </Menu.Item>

            <Menu.Item
              key="pdv"
              icon={<FaCashRegister />}
            >
              <Link to="/pdv">PDV</Link>
            </Menu.Item>

            <Menu.Item
              key="business"
              icon={<FaWhatsapp />}
            >
              <a
                href="https://wa.me/91983744682?text=Canal%20de%20vendas%20Bebilogo!"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp Business
              </a>
            </Menu.Item>
          </SubMenu>

          {/* =========================
              DESPESAS & RECEITAS
          ========================== */}
          <SubMenu
            key="financeiro"
            icon={<FaMoneyBillTransfer />}
            title="Despesas & Receitas"
          >
            <Menu.Item
              key="despesas"
              icon={<FaArrowTrendDown />}
            >
              <Link to="/expenses">Despesas</Link>
            </Menu.Item>

            <Menu.Item
              key="receitas"
              icon={<FaArrowTrendUp />}
            >
              <Link to="/revenues">Receitas</Link>
            </Menu.Item>
          </SubMenu>

          {/* =========================
              PRODUTOS & ESTOQUE
          ========================== */}
          <SubMenu
            key="produtos"
            icon={<AppstoreOutlined />}
            title="Produtos & Estoque"
          >
            <Menu.Item
              key="produtos-lista"
              icon={<FaCube />}
            >
              <Link to="/produtos">Produtos</Link>
            </Menu.Item>

            <Menu.Item
              key="movimentos"
              icon={<FaRightLeft />}
            >
              <Link to="/storemoviments">
                Entrada e Saída
              </Link>
            </Menu.Item>

            <Menu.Item
              key="sugestao"
              icon={<FaHandshake />}
            >
              <Link to="/sugestao">
                Sugestão de Compra
              </Link>
            </Menu.Item>

            <Menu.Item
              key="estoque"
              icon={<FaCubes />}
            >
              <Link to="/estoque">Estoque</Link>
            </Menu.Item>
          </SubMenu>

          {/* =========================
              PROSPECÇÃO
          ========================== */}
          <SubMenu
            key="crm"
            icon={<FaCompressArrowsAlt />}
            title="Prospecção de Clientes"
          >
            <Menu.Item
              key="crm-menu"
              icon={<FaCompressArrowsAlt />}
            >
              <Link to="/crm">CRM</Link>
            </Menu.Item>
          </SubMenu>

          {/* =========================
              INTEGRAÇÕES
          ========================== */}
          <SubMenu
            key="integracoes"
            icon={<FaCompressAlt />}
            title="Integrações"
          >
            {/* Mercado Pago */}
            <SubMenu
              key="checkout_mp"
              icon={<AiOutlineCluster />}
              title="Mercado Pago"
            >
              <Menu.Item
                key="mp_credenciais"
                icon={<AiOutlineCheck />}
              >
                <Link to="/mpcredenciais">
                  Credenciais
                </Link>
              </Menu.Item>

              <Menu.Item
                key="mp_pagamentos"
                icon={<AiOutlineCheck />}
              >
                <Link to="/mppayments">
                  Pagamentos
                </Link>
              </Menu.Item>

              <Menu.Item
                key="mp_criar_cobranca"
                icon={<AiOutlineCheck />}
              >
                <Link to="/checkout-mercadopago">
                  Criar Cobrança Teste
                </Link>
              </Menu.Item>
            </SubMenu>
          </SubMenu>

          {/* =========================
              DESEMPENHO
          ========================== */}
          <SubMenu
            key="desempenho"
            icon={<BarChartOutlined />}
            title="Desempenho"
          >
            <Menu.Item
              key="desempenho-menu"
              icon={<BarChartOutlined />}
            >
              <Link to="/desempenhos">
                Desempenho
              </Link>
            </Menu.Item>
          </SubMenu>

          {/* =========================
              CONFIGURAÇÕES
          ========================== */}
          <SubMenu
            key="config"
            icon={<SettingOutlined />}
            title="Configurações"
          >
            <Menu.Item
              key="usuarios"
              icon={<TeamOutlined />}
            >
              <Link to="/users">
                Seu(s) Cliente(s)
              </Link>
            </Menu.Item>

            <Menu.Item
              key="categorias"
              icon={<PictureOutlined />}
            >
              <Link to="/categories">
                Categoria(s)
              </Link>
            </Menu.Item>

            <Menu.Item
              key="minimo"
              icon={<FaMoneyBillTransfer />}
            >
              <Link to="/config">
                Valor mínimo por pedido
              </Link>
            </Menu.Item>

            <Menu.Item
              key="delivery"
              icon={<FaMotorcycle />}
            >
              <Link to="/delivery">
                Cálculo Frete
              </Link>
            </Menu.Item>

            <Menu.Item
              key="horario"
              icon={<ClockCircleOutlined />}
            >
              <Link to="/horario">
                Horários
              </Link>
            </Menu.Item>

            <Menu.Item
              key="pesquisas"
              icon={<SearchOutlined />}
            >
              <Link to="/pesquisas">
                Pesquisas
              </Link>
            </Menu.Item>
          </SubMenu>

          {/* =========================
              AJUDA
          ========================== */}
          <Menu.Item
            key="ajuda"
            icon={<QuestionCircleOutlined />}
          >
            <Link to="/help">Ajuda</Link>
          </Menu.Item>
        </Menu>
      </Drawer>
    </>
  );
};

export default CustomHeader;